import { render, staticRenderFns } from "./OrgWallets.vue?vue&type=template&id=4f021590&scoped=true&"
import script from "./OrgWallets.vue?vue&type=script&lang=js&"
export * from "./OrgWallets.vue?vue&type=script&lang=js&"
import style0 from "./OrgWallets.vue?vue&type=style&index=0&id=4f021590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f021590",
  null
  
)

export default component.exports